<h2
    mat-dialog-title
    class="cut-long-text"
>{{ data?.id ? ("product.dialog_title_edit" | transloco) : ("product.dialog_title_create" | transloco) }}</h2>
<mat-divider></mat-divider>
<br />
<mat-dialog-content>
    <mat-tab-group id="tab-group">
        <form [formGroup]="form">
            <mat-tab label="{{ 'product.tab_general' | transloco }}">
                <br />
                <mat-form-field class="full-width">
                    <mat-label>{{ "product.isbn" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="isbn"
                    />
                    @if (form.get("isbn")?.hasError("regex")) {
                    <mat-error>{{ "product.isbn_invalid" | transloco }}</mat-error>
                    }
                    @if (form.get("isbn")?.hasError("unique")) {
                    <mat-error>{{ "product.isbn_duplicate" | transloco }}</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>{{ "name" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="name"
                    />
                </mat-form-field>
            </mat-tab>
            <mat-tab label="{{ 'product.tab_imprint' | transloco }}">
                <br />
                <div class="imprint-active-toggle">
                    <mat-checkbox formControlName="imprintActive">
                        {{ "product.imprint_active" | transloco }}
                    </mat-checkbox>
                </div>
                <div class="editor-field">
                    <pixl-editor
                        class="full-width"
                        [htmlString]="form.get('imprint')?.value"
                        [bearerToken]="authToken!"
                        [assetUrl]="assetsUrl"
                        [mediaUrl]="mediaUrl"
                        editorHeight="600px"
                        (editedHtmlStringChange)="form.patchValue({ imprint: $event })"
                    ></pixl-editor>
                </div>
            </mat-tab>
        </form>
    </mat-tab-group>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        (click)="cancel()"
    >{{ "cancel" | transloco }}</button>
    <button
        mat-raised-button
        color="primary"
        (click)="save()"
    >{{ "save" | transloco }}</button>
</mat-dialog-actions>